import { Modal, Button } from "react-bootstrap";

const DeleteConfirmation = ({
  showModal,
  hideModal,
  confirmModal,

  message,
}) => {
  return (
    <Modal show={showModal} onHide={hideModal}>
      <Modal.Header closeButton>
        <Modal.Title>Bestätigung zum Löschen</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-danger">{message}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="default" onClick={hideModal}>
          Abbrechen
        </Button>
        <Button variant="danger" onClick={() => confirmModal()}>
          Löschen
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmation;
